module.exports = __webpack_public_path__ + "img/VS.08e5e7d4.png";